import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useQuery } from "convex/react";
import { api } from "@/convex/_generated/api";
import ResetPasswordWithEmailCode from "@/components/auth/reset-password";
import {
  AuthLeftPanel,
  AuthMobileLogo,
  AuthRightPanel,
} from "@/components/auth/auth-layout";

export const Route = createFileRoute("/_public/auth/reset-password")({
  component: ResetPasswordPage,
});

function ResetPasswordPage() {
  const navigate = useNavigate();
  // Este flujo depende del OTP por email. Sin RESEND en el backend (on-prem) no
  // puede funcionar: aunque ocultemos el enlace, alguien podría entrar por URL,
  // así que la ruta misma redirige al sign-in.
  const emailEnabled = useQuery(
    api.system.onboarding.queries.isPasswordResetEmailEnabled,
  );

  useEffect(() => {
    if (emailEnabled === false) navigate({ to: "/auth/sign-in" });
  }, [emailEnabled, navigate]);

  const handleCancel = () => {
    navigate({ to: "/auth/sign-in" });
  };

  if (emailEnabled === false) return null;

  return (
    <div className="relative min-h-screen">
      <AuthLeftPanel
        headline="Recupera el acceso a tu cuenta."
        subtitle="Restablece tu contraseña de forma segura y vuelve a lo que estabas construyendo."
        badge=""
      />

      <AuthRightPanel>
        <AuthMobileLogo />
        <ResetPasswordWithEmailCode
          handleCancel={handleCancel}
          provider="password"
        />
      </AuthRightPanel>
    </div>
  );
}
